/**
 * De drie deel-links van een vragenlijst: de invul-URL, de QR-pagina en het
 * printvel.
 *
 * Eén bron voor 'Vragenlijst delen', het tabblad Vragenlijst in een afspraak en
 * het tabblad Onderzoek bij een huisbezoek — die bouwden alle drie hun eigen
 * versie van dezelfde paden.
 * AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook
 *
 * @param {object} params
 * @param {string} params.client - Tenant CompagnyID (het eerste URL-segment)
 * @param {string} params.questionnaireID - Questionnaires.ID
 * @param {string} params.measureMomentID - MeasureMoments.ID
 * @param {string} params.researchID - Research.ID
 * @param {string} [params.respondentID] - Personas.ID of Adresses.ID; leeg = anoniem
 * @param {string} [params.language] - Taalcode, standaard 'nl'
 * @returns {{open: string, qrcode: string, print: string}|null} `null` zolang
 *   een id ontbreekt
 */
const buildQuestionnaireShareLinks = ({
    client,
    questionnaireID,
    measureMomentID,
    researchID,
    respondentID,
    language,
}) => {
    if (!client || !questionnaireID || !measureMomentID || !researchID) return null

    // 'undefined' is hier het afgesproken segment voor 'anoniem ingevuld' — geen
    // per ongeluk doorgelekte waarde.
    const respondent = respondentID || 'undefined'
    const lang = language || 'nl'

    return {
        open: `/${client}/questionnaireopen/${questionnaireID}/${measureMomentID}/${researchID}/${respondent}/open/${lang}`,
        qrcode: `/${client}/qrcode/${questionnaireID}/${measureMomentID}/${researchID}/${respondent}/${lang}/research`,
        // De printpagina leest zijn segmenten op vaste posities (3 t/m 7) en
        // heeft geen 'open'-segment zoals de invul-URL. Verschuif er één en de
        // pagina toont een lege vragenlijst in plaats van een fout.
        print: `/${client}/printquestionaire/${questionnaireID}/${measureMomentID}/${researchID}/${respondent}/${lang}`,
    }
}

export default buildQuestionnaireShareLinks
